import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './navbar.css';
const logo = 'http://lawina.boleslawiec.zhp.pl/assets/logos/lawina.webp';

const fbIcon = "https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg";
const igIcon = "https://upload.wikimedia.org/wikipedia/commons/9/95/Instagram_logo_2022.svg";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`main-nav ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        
        <NavLink to="/" className="nav-brand" onClick={() => setMenuOpen(false)}>
          <img src={logo} alt="Logo Lawina" />
          <div className="brand-text">
            <span className="brand-name">Szczep Harcerski „Lawina”</span>
            <span className="brand-sub">Hufiec Bolesławiec</span>
          </div>
        </NavLink>

        <div className={`hamburger ${menuOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>

        <ul className={`nav-links ${menuOpen ? 'active' : ''}`}>
          <li><NavLink to="/" end onClick={() => setMenuOpen(false)}>Start</NavLink></li>
          <li><NavLink to="/komenda" onClick={() => setMenuOpen(false)}>Komenda</NavLink></li>
          <li><NavLink to="/historia" onClick={() => setMenuOpen(false)}>Historia</NavLink></li>
          <li><NavLink to="/druzyny" onClick={() => setMenuOpen(false)}>Jednostki</NavLink></li>
          {/* <li><NavLink to="/oboz" onClick={() => setMenuOpen(false)}>Obóz 2026</NavLink></li> */}
          {/* <li><NavLink to="/posty" onClick={() => setMenuOpen(false)}>Ostatnie posty</NavLink></li> */}
          <li><NavLink to="/wesprzyj" onClick={() => setMenuOpen(false)}>Wesprzyj nas</NavLink></li>
          
          <li className="mobile-socials">
            <a href="https://www.facebook.com/profile.php?id=61584048825320" target="_blank" rel="noreferrer"><img src={fbIcon} alt="FB" /></a>
            <a href="https://www.instagram.com/zd_lawina/" target="_blank" rel="noreferrer"><img src={igIcon} alt="IG" /></a>
          </li>
        </ul>
        <div className="nav-socials-desktop">
          <a href="https://www.facebook.com/profile.php?id=61584048825320" target="_blank" rel="noreferrer"><img src={fbIcon} alt="FB" /></a>
          <a href="https://www.instagram.com/zd_lawina/" target="_blank" rel="noreferrer"><img src={igIcon} alt="IG" /></a>
        </div>

      </div>
    </nav>
  );
}

export default Navbar;